var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 16.53a.82.82 0 00-.27-.62l-.32-.32-6.29-6.33a1 1 0 00-1.31 0l-.45.45a1 1 0 00.08 1.39L16 15.25H6.82a.76.76 0 01-.75-.75V1.16a1.25 1.25 0 00-2.5 0V14.5a3.25 3.25 0 003.25 3.25H16L11.75 22a.91.91 0 000 1.29l.45.45a.87.87 0 001.23.08l6.35-6.32.36-.28a.86.86 0 00.26-.69z"
  })));
}
export default SvgAccordionArrow;